import Alpine from 'alpinejs'
window.Alpine = Alpine
Alpine.start()

import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

Array.from(document.querySelectorAll("[data-lightbox]")).forEach(element => {
  console.log(element);
  element.onclick = (e) => {
    e.preventDefault();
    basicLightbox.create(`<img src="${element.href}">`).show();
  };
});

const swiperAvis = new Swiper(".avisSwiper", {
  // configure Swiper to use modules
  modules: [Navigation, Pagination],
  slidesPerView: 1,
  spaceBetween: -36,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
  },
  breakpoints: {
    640: {
      slidesPerView: 2,
      spaceBetween: 16,
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 16,
    },
    1024: {
      slidesPerView: 3,
      spaceBetween: 16,
    },
  },
  mousewheel: true,
  keyboard: true,
});

const swiperReferences = new Swiper(".referencesSwiper", {
  // configure Swiper to use modules
  modules: [Navigation, Pagination],
  slidesPerView: 1,
  spaceBetween: 16,
  loop: true,
  navigation: {
    nextEl: ".swiperRef-button-next",
    prevEl: ".swiperRef-button-prev",
  },
  breakpoints: {
    640: {
      slidesPerView: 2,
      spaceBetween: 16,
    },
    768: {
      slidesPerView: 4,
      spaceBetween: 16,
    },
    1024: {
      slidesPerView: 5,
      spaceBetween: 16,
    },
  },
  mousewheel: true,
  keyboard: true,
});


